import React from 'react';
import logoIcon from '../assets/icons/logo.svg';
import telegramIcon from '../assets/icons/telegram.svg';

const buttons = [
    { label: 'SSN Search Bot', href: 'https://t.me/TrustFinderTwo_bot', variant: 'primary' },
    { label: 'News BOT', href: 'https://t.me/TrustListNewsbot', variant: 'primary' },
    { label: 'ADS Here', href: 'https://t.me/OVERSEER4', variant: 'secondary' },
];

function ActionButton({ label, href, variant }) {
    const primary = variant === 'primary';
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-2 px-3 py-1 rounded-lg text-white hover:opacity-90 transition-opacity font-manrope text-sm leading-[1.4285714285714286em] ${primary ? 'bg-[#FF00A7]' : 'border border-[#FF00A7]'}`}
            style={primary ? undefined : {
                background: 'linear-gradient(180deg, rgba(255, 0, 167, 0) 0%, rgba(255, 0, 167, 0.5) 100%)',
            }}
        >
            <img src={telegramIcon} alt="Telegram" className="w-3 h-3" />
            <span>{label}</span>
        </a>
    );
}

export default function Header() {
    return (
        <>
            <div className="w-full flex justify-center py-4 px-4 md:px-6">
                <div className="w-full max-w-[1140px]">
                    {/* Header Menu Outer */}
                    <div className="py-4">
                        {/* Header Menu Inner */}
                        <div
                            className="flex flex-row justify-between items-center px-5 py-3 rounded-xl relative"
                            style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.02)',
                                border: '1px solid rgba(255, 255, 255, 0.16)',
                                boxShadow: 'inset 0px -4px 48px -24px rgba(255, 0, 167, 0.32)',
                                backdropFilter: 'blur(32px)',
                            }}
                        >
                            {/* Logo */}
                            <a href="/" className="flex items-center gap-2 relative z-0">
                                <img src={logoIcon} alt="Logo" className="w-6 h-[22.9px]" />
                                <span className="text-white font-bold text-sm leading-[1.7142857142857142em] font-manrope">
                                    Trust List
                                </span>
                            </a>

                            {/* Desktop: Buttons on the right */}
                            <div className="hidden lg:flex items-center gap-4">
                                {buttons.map((btn) => (
                                    <ActionButton key={btn.label} {...btn} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Tablet & Mobile: Buttons below the header (centered) */}
            <div className="flex lg:hidden w-full justify-center px-4 md:px-6 pb-4">
                <div className="w-full max-w-[1140px]">
                    <div className="flex flex-wrap items-center justify-center gap-4">
                        {buttons.map((btn) => (
                            <ActionButton key={btn.label} {...btn} />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
